export function objectToSearchParams<TObject extends Parameters<typeof Object.entries>[0]>(
  object: TObject,
): URLSearchParams {
  const params = new URLSearchParams();

  Object.entries(object)
    .flatMap(([name, value]) => {
      if (Array.isArray(value)) {
        return value.map((innerValue) => [name, innerValue]);
      }

      if (value === null || typeof value === 'undefined' || value === false) {
        return [];
      }

      return [[name, value]];
    })
    .forEach(([name, value]) => {
      if (value === true) {
        params.append(name, '');
      } else {
        params.append(name, value);
      }
    });

  return params;
}
